import {React, useEffect} from 'react';
import { Box, Card, CardContent, Typography, TextField, Button, Container } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export const Contact = () => {
  useEffect(() => {
  document.title = "Home - Pest Control Raipur Services";
}, []);
return (
  <Container>
  <Card variant="outlined" sx={{ mt: 4, p: 3 }}>
    <CardContent>
    <Typography variant="h5" gutterBottom>Locate Us</Typography>

    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7435.896421873994!2d81.63134609999999!3d21.273517500000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a28dd1e5b5b5b5b%3A0x5b5b5b5b5b5b5b5b!2sPest%20Control%20Raipur%20Services!5e0!3m2!1sen!2sin!4v1742218117024!5m2!1sen!2sin"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Pest Control Raipur Services Location"
            ></iframe>
          </Box>
          <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="body1">
              <b>Pest Control (Raipur) Services</b><br />
              <i>Sector - 1, Saptgiri Colony, Shivanand Nagar</i><br />
              <i>Raipur, Chhattisgarh</i><br />
              <i>India - 492008</i>
            </Typography>
          </Box>
      </Box>
    </CardContent>
  </Card>
    <Card variant="outlined" sx={{ mt: 4, p: 3, textAlign: 'center' }}>
      <CardContent>
        <PhoneIcon sx={{ fontSize: 80, color: 'primary.main' }} />
        <Typography variant="h5" gutterBottom>Instantly book a consultation and get a quote on your pest treatment.</Typography>
        <Box sx={{ bgcolor: '#0047AB', color: 'white', p: 2, borderRadius: 1, display: 'inline-block' }}>
          <Typography>Call Us @ <a href="tel:+919584841666" style={{ color: 'white' }}>+91 9584841666</a> / <a href="tel:+919329108416" style={{ color: 'white' }}>+91 9329108416</a></Typography>
        </Box>
      </CardContent>
    </Card>
    <Card variant="outlined" sx={{ mt: 4, p: 3, textAlign: 'center' }}>
      <CardContent>
        <WhatsAppIcon sx={{ fontSize: 80, color: 'primary.main' }} />
        <Typography variant="h5" gutterBottom>WhatsApp your query and we will get back to you as soon as possible.</Typography>
        <Box sx={{ bgcolor: '#0047AB', color: 'white', p: 2, borderRadius: 1, display: 'inline-block' }}>
          <Typography><a href="https://wa.me/919584841666" style={{ color: 'white' }}>WhatsApp Us</a></Typography>
        </Box>
      </CardContent>
    </Card>
    <Card variant="outlined" sx={{ mt: 4, p: 3, textAlign: 'center' }}>
      <CardContent>
        <Typography variant="h5" gutterBottom>Contact Form</Typography>
        <Typography>Kindly take a moment to fill out this contact form so that we can provide you the best possible solution.</Typography>
        <br/>
        <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 400, mx: 'auto' }}>
          <TextField label="Name" variant="outlined" fullWidth required />
          <TextField label="Email" variant="outlined" fullWidth required />
          <TextField label="Mobile Number" variant="outlined" fullWidth required />
          <TextField label="Best Time to Call" variant="outlined" fullWidth />
          <TextField label="Address Postcode" variant="outlined" fullWidth required />
          <TextField label="Service Query" variant="outlined" fullWidth multiline rows={4} required />
          <Button variant="contained" color="primary" type="submit">Submit</Button>
        </Box>
      </CardContent>
    </Card>
  </Container>
);
};